import { useNavigate } from "react-router-dom"
import { ChevronLeft } from "@mui/icons-material"
import { Box, Button } from "@mui/material"
import { LoadingButton } from "@mui/lab"

export default function BackAndNextButton({
  loading,
  disabled = false,
  backButtonLabel = 'Previous Page',
  backButtonPath,
  NextButtonComponent,
  nextButtonLabel,
  nextButtonPath,
  nextButtonType = "button",
}) {
  const navigate = useNavigate()

  return (
    <Box
      display="flex"
      justifyContent="start"
      my={2}
      sx={{
        flexDirection: {
          xs: "column-reverse",
          sm: "row",
        },
      }}
    >
      <Button
        variant="text"
        size="large"
        sx={{ fontWeight: "normal", height: 60, textTransform: "none", mr: 2 }}
        onClick={() => navigate(backButtonPath)}
      >
        <ChevronLeft /> {backButtonLabel}
      </Button>
      {NextButtonComponent ? (
        <NextButtonComponent />
      ) : (
        <LoadingButton
          loading={loading}
          disabled={disabled}
          type={nextButtonType}
          variant="contained"
          size="large"
          sx={{ fontWeight: 500, height: 60, textTransform: "none" }}
          onClick={() => {
            if (nextButtonType !== "submit" && nextButtonPath) {
              navigate(nextButtonPath)
            }
          }}
        >
          {nextButtonLabel}
        </LoadingButton>
      )}
    </Box>
  )
}
